var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgButtonDelete = function SvgButtonDelete(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.94 0 0 8.94 0 20C0 31.06 8.94 40 20 40C31.06 40 40 31.06 40 20C40 8.94 31.06 0 20 0ZM20 36C11.18 36 4 28.82 4 20C4 11.18 11.18 4 20 4C28.82 4 36 11.18 36 20C36 28.82 28.82 36 20 36ZM27.18 10L20 17.18L12.82 10L10 12.82L17.18 20L10 27.18L12.82 30L20 22.82L27.18 30L30 27.18L22.82 20L30 12.82L27.18 10Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgButtonDelete);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjAgMEM4Ljk0IDAgMCA4Ljk0IDAgMjBDMCAzMS4wNiA4Ljk0IDQwIDIwIDQwQzMxLjA2IDQwIDQwIDMxLjA2IDQwIDIwQzQwIDguOTQgMzEuMDYgMCAyMCAwWk0yMCAzNkMxMS4xOCAzNiA0IDI4LjgyIDQgMjBDNCAxMS4xOCAxMS4xOCA0IDIwIDRDMjguODIgNCAzNiAxMS4xOCAzNiAyMEMzNiAyOC44MiAyOC44MiAzNiAyMCAzNlpNMjcuMTggMTBMMjAgMTcuMThMMTIuODIgMTBMMTAgMTIuODJMMTcuMTggMjBMMTAgMjcuMThMMTIuODIgMzBMMjAgMjIuODJMMjcuMTggMzBMMzAgMjcuMThMMjIuODIgMjBMMzAgMTIuODJMMjcuMTggMTBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";